var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;}.a{stroke:#007a7a;stroke-linejoin:round;stroke-width:1.5px;}.b{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1066 -763)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(1066 763)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 0.75,
    y: 0.75,
    width: 16.5,
    height: 16.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(1070 767)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 10,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 0.75,
    y: 0.75,
    width: 8.5,
    height: 8.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderIcon);
export default __webpack_public_path__ + "static/media/border-icon.06384b89d5a2320b9e4ea2633991d1a1.svg";
export { ForwardRef as ReactComponent };